import { Utils } from "../utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface IAddressData {
    label: string;
    countryCode: string;
    countryName: string;
    state: string;
    country: string;
    city: string;
    district: string;
    street: string;
    postalCode: string;
    houseNumber: string;
}

export class AddressData implements IAddressData {

    constructor(data?: IAddressData) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IAddressData) {
        mapData(data, { root: () => this });
    }

    label: string = "";
    countryCode: string = "";
    countryName: string = "";
    state: string = "";
    country: string = "";
    city: string = "";
    district: string = "";
    street: string = "";
    postalCode: string = "";
    houseNumber: string = "";

}